module.exports = "/images/ny-life1-7.jpg";